import { render } from "./VoteAcceptConsent.vue?vue&type=template&id=5349763c&scoped=true&ts=true"
import script from "./VoteAcceptConsent.vue?vue&type=script&lang=ts"
export * from "./VoteAcceptConsent.vue?vue&type=script&lang=ts"

import "./VoteAcceptConsent.vue?vue&type=style&index=0&id=5349763c&lang=scss&scoped=true"

import exportComponent from "/home/node/app/.yarn/__virtual__/vue-loader-virtual-2429a647ea/0/cache/vue-loader-npm-17.0.0-6ebaa2d3c5-0c0a647a4e.zip/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5349763c"]])

export default __exports__